import {createContext} from 'react'

const EstatusValeContext = createContext()

export default EstatusValeContext